import {Form, InputNumber, Modal,  App,   Input,  Row, Col, DatePicker, Space,} from 'antd'     
import { useDingdanshouruAddMutation,  useSKaddtijiaoMutation } from '../../store/DianShangYeWuApi';
import React, { useState } from 'react'
import classes from './income.module.css'
import Icon from '../../cpn/Icon';
import OCRTextArea from '../../cpn/OCRTextArea';
import UploadPic from '../../cpn/UploadPic';
import ClientSelect from '../../system/client/ClientSelect';
import dayjs from 'dayjs';
import DocumentRule from '../../cpn/DocumentRule';
import Asterisk from '../../cpn/Asterisk';
import IncomeNodeAdd from './IncomeNodeAdd';
import ArapTypeSelect from '../../cpn/ArapTypeSelect';
function IncomeAddReportEdit(props) {
    const { message } = App.useApp();
    const [open,setOpen] = useState(false);
    const [info,setInfo] = useState({
        'ddsr_price': '0.01',
        'ddsr_uid': props.yh_id,
        'ddsr_uname': props.yh_name,
        'ddsr_content': '',
        'ddsr_bzd_id': props.dsbzd_id,
        'ddsr_kh_id': '',
        'ddsr_kh_name': '',
        'ddsr_type_id': '',
        'ddsr_type_name': '',
        'ddsr_amount': '',
        'ddsr_qy_id': '',
        'ddsr_qy_name': '',
        'ddsr_num': '1',
        'ddsr_date': props.dsbzd_date,
        'ddsr_bzd_name': '',
        'ddsr_bzd_date': '',
        'ddsr_bzd_xuhao': '',
        'ddsr_name': '',
        'ddsr_bzd_date_end': '',
        'ddsr_qyyhzh_id': '',
        'ddsr_qyyhzh_name': '',
        'ddsr_bm_id': props.dsbzd_bm_id,
        'ddsr_bm_name': props.dsbzd_bm_name,
        'ddsr_image_name': '',
        'ddsr_image_file': '',
        'ddsr_state': '',
        'ddsr_zflx': ''
    })
    const [form] = Form.useForm();
    const [add] = useDingdanshouruAddMutation();
    
    // 当面板打开时重置表单到初始值
    React.useEffect(() => {
        if (open) {
            form.resetFields();
        }
    }, [open, form]);
    //提交
    const [addtijiao] = useSKaddtijiaoMutation()
    const [isSubmitting, setIsSubmitting] = useState(false)
    return (
        <>
            <Icon type='add' onClick={() => {setOpen(true)}} />
            <Modal
                open={open} 
                onCancel={() => {setOpen(false)}}
                width={1330}
                form={form}
                footer={null}
            >
                <Form
                    form={form}
                    className={classes.form}
                    labelCol={{ span: 7}}
                    wrapperCol={{ span: 17 }}
                    initialValues={{
                        ddsr_price: 0.01,
                        ddsr_num: 1,
                        ddsr_date: props.dsbzd_date ? dayjs(props.dsbzd_date) : undefined,
                        ddsr_bm_name: props.dsbzd_bm_id ? String(props.dsbzd_bm_id) : undefined, // Select 需要的是 value（ID），统一转换为字符串
                    }}
                >
                    <Row style={{width:"1280px"}}>
                        <Col span={4} className={classes.row_top_left} style={{borderTop:'3px solid #FF0033',borderLeft:'3px solid #FF0033'}}></Col>
                        <Col span={16} className={classes.row_top_middle} style={{color:'#FF0033',borderTop:'3px solid #FF0033'}}>收款单</Col>
                        <Col span={4} className={classes.row_top_right} style={{borderTop:'3px solid #FF0033',borderRight:'3px solid #FF0033'}}></Col>
                         {/* 第一行 */}
                        <Col span={2} className={classes.col_top_label} style={{borderLeft:'3px solid #FF0033',color:'#FF0033'}}><Asterisk color='red'/> 收款事由</Col>
                        <Col span={6}  className={classes.col_top_input}>
                            <Form.Item name='ddsr_name' noStyle>
                                <Input 
                                    placeholder='请输入收款事由' 
                                    onChange={(e) => {
                                        setInfo(prevState => ({ ...prevState, ddsr_name: e.target.value }))
                                    }}
                                />
                            </Form.Item>
                        </Col>  
                        <Col span={2} className={classes.col_top_label} ><Asterisk color='red'/> 客户</Col>
                        <Col span={6}  className={classes.col_top_input} style={{display:'flex',alignItems:'center',justifyContent:'left'}}>
                            <ClientSelect
                                name='ddsr_kh_name'
                                placeholder='请选择客户'
                                onChange={(value,label) => {
                                    setInfo(prevState => ({ ...prevState, ddsr_kh_id: value, ddsr_kh_name: label }))
                                }}
                                style={{width: '230px'}}
                                formStyle={{marginBottom: 0,width: '100%'}}
                                qy_id={props.qy_id}
                                yh_id={props.yh_id}
                                defaultId={info.ddsr_kh_id}
                                wrapperCol={{span:24}}
                                clientAdd={true}
                            />
                        </Col>  
                        <Col span={2}  className={classes.col_top_label} ><Asterisk color='red'/> 部门</Col>
                        <Col span={6}  className={classes.col_right_input}  style={{borderRight:'3px solid #FF0033'}}>
                           {props.dsbzd_bm_name}
                        </Col> 
                        {/* 第二行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #FF0033'}}><Asterisk color='red'/> 日期</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                            <Form.Item name='ddsr_date' noStyle>
                                <DatePicker 
                                    placeholder='请选择日期' 
                                    onChange={(value) => {
                                        setInfo(prevState => ({ ...prevState, ddsr_date: value ? value.format('YYYY-MM-DD') : '' }))
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 金额</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                            <Form.Item 
                                name='ddsr_amount'
                                noStyle
                            >
                                <InputNumber 
                                    placeholder='请输入金额' 
                                    onChange={(value) => {
                                        setInfo(prevState => ({ ...prevState, ddsr_amount: value }))
                                    }}
                                    style={{ width: '310px' }}
                                    min={0.01}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 往来类型</Col>
                        <Col span={6}  className={classes.col_middle_right_input}   style={{borderRight:'3px solid #FF0033'}}>
                            <ArapTypeSelect 
                                documentType='income' 
                                onChange={(value) => {
                                    setInfo(prevState => ({ ...prevState, ddsr_zflx: value }))
                                }}
                                name='ddsr_zflx'
                                required={true}
                                style={{marginBottom: 0}}
                                wrapperCol={{span:24}}
                                disabled='核销应收'
                            />
                        </Col>
                        {/* 第三行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #FF0033'}}> 备注</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                            <Form.Item name='ddsr_content' noStyle>
                                <OCRTextArea
                                    value={info.ddsr_content}
                                    onChange={(e) => {
                                        setInfo(prevState => ({ ...prevState, ddsr_content: e.target.value }))
                                    }}
                                    language="chi_sim"
                                />
                            </Form.Item>
                        </Col>                        
                        <Col span={2} className={classes.col_middle_label}>团队名称</Col>
                        <Col span={6}  className={classes.col_middle_right_input} >
                            {props.dsbzd_name}
                        </Col>                                       
                        <Col span={2}  className={classes.col_middle_label}> 转账记录</Col>
                        <Col span={6}  className={classes.col_middle_input} style={{borderRight:'3px solid #FF0033',padding:'20px 5px'}}>
                            
                        </Col>                                   
                        {/* 第四行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #FF0033'}}> 附件</Col>
                        <Col span={14}  className={classes.col_middle_input}>
                            <UploadPic
                                name='ddsr_image'
                                onChange={(e,f) => {
                                    setInfo(prevState => ({ ...prevState, ddsr_image_file: e, ddsr_image_name: f }))
                                }}
                                maxCount={5}
                                style={{ width: '100%' }}
                                formStyle={{marginBottom: 0,width: '100%'}}
                            />
                        </Col>
                        <Col span={2} className={classes.col_middle_label}>编号/状态</Col>
                        <Col span={6}  className={classes.col_middle_right_input} style={{display:'flex',alignItems:'center',justifyContent:'left',borderRight:'3px solid #FF0033'}}></Col>    
                         {/* 第五行 */}  
                        <Col span={24}  className={classes.row_bottom} >
                            <IncomeNodeAdd qy_id={props.qy_id} user_id={props.yh_id} yh_name={props.yh_name}/>
                        </Col>
                    </Row>   
                    <Row>
                        <Col span={24} style={{textAlign: 'right',paddingTop: '10px',display:'flex',justifyContent:'space-between'}}>
                            <DocumentRule/>
                            <Space size={20}>
                                <Icon 
                                    type='save' 
                                    title='保存不提交'
                                    onClick={() => {
                                        if(info.ddsr_name === '' || info.ddsr_name === 'undefined'){
                                            message.error('请输入收款事由');
                                            return;
                                        }
                                        if(info.ddsr_amount === ''){
                                            message.error('请输入金额');
                                            return;
                                        }
                                        if(info.ddsr_kh_id === ''){
                                            message.error('请选择客户');
                                            return;
                                        } 
                                        if(info.ddsr_date === ''){
                                            message.error('请选择日期');
                                            return;
                                        }                                      
                                        if(info.ddsr_bm_id === ''){
                                            message.error('请选择部门');
                                            return;
                                        }
                                        if(props.dsbzd_id === '' || props.dsbzd_id === 'undefined'){
                                            message.error('团队报账单错误');
                                            return;
                                        }
                                        if(info.ddsr_zflx === ''){
                                            message.error('请选择往来类型');
                                            return;
                                        }
                                        add({
                                            'ddsr_price': info.ddsr_price,
                                            'ddsr_uid': props.yh_id,
                                            'ddsr_uname': props.yh_name,
                                            'ddsr_content': info.ddsr_content,
                                            'ddsr_bzd_id': props.dsbzd_id,
                                            'ddsr_kh_id': info.ddsr_kh_id,
                                            'ddsr_kh_name': info.ddsr_kh_name,
                                            'ddsr_type_id': info.ddsr_type_id,
                                            'ddsr_type_name': info.ddsr_type_name,
                                            'ddsr_amount': info.ddsr_amount,
                                            'ddsr_qy_id': props.qy_id,
                                            'ddsr_qy_name': props.qy_name,
                                            'ddsr_num': info.ddsr_num,
                                            'ddsr_date': info.ddsr_date ? info.ddsr_date:props.dsbzd_date,
                                            'ddsr_bzd_name': props.dsbzd_name,
                                            'ddsr_bzd_date': props.dsbzd_date,
                                            'ddsr_bzd_xuhao': '',
                                            'ddsr_name': info.ddsr_name,
                                            'ddsr_bzd_date_end': props.dsbzd_date_end,
                                            'ddsr_qyyhzh_id': info.ddsr_qyyhzh_id,
                                            'ddsr_qyyhzh_name': info.ddsr_qyyhzh_name,
                                            'ddsr_bm_id': info.ddsr_bm_id?info.ddsr_bm_id:props.dsbzd_bm_id,
                                            'ddsr_bm_name': info.ddsr_bm_name?info.ddsr_bm_name:props.dsbzd_bm_name,
                                            'ddsr_image_name': info.ddsr_image_name?info.ddsr_image_name:'',
                                            'ddsr_image_file': info.ddsr_image_file?info.ddsr_image_file:'',
                                            'ddsr_state': '1',
                                            'ddsr_zflx': info.ddsr_zflx,
                                            'spdd_sp_id': '14',
                                            'spdd_sp_name': '财务管理',
                                            'spdd_spgg_id': '18',
                                            'spdd_spgg_name': '收款单',
                                            'spdd_spgg_price': '0.1',
                                            'spdd_state': '支出'
                                        }).then(res => {
                                            if(res.data.Status==='success'){
                                                setOpen(false);
                                                message.success('保存成功');
                                                form.resetFields();  
                                            }else{
                                                message.error('保存失败！' + res.data.Message);
                                            }
                                        })     
                                    }} 
                                />
                                <Icon 
                                    type='reset' 
                                    onClick={() => {
                                        form.resetFields();
                                        setInfo(prevState => ({ 
                                            ...prevState, 
                                            ddsr_price: 0.01, 
                                            ddsr_num: 1, 
                                            ddsr_amount: 0.01, 
                                            ddsr_content: '',                             
                                            ddsr_type_id: '', 
                                            ddsr_type_name: '', 
                                            ddsr_kh_id: '', 
                                            ddsr_kh_name: '', 
                                            ddsr_qyyhzh_id: '', 
                                            ddsr_qyyhzh_name: '',
                                            ddsr_bm_id: '',
                                            ddsr_bm_name: '',
                                            ddsr_image_name: '',
                                            ddsr_image_file: '',
                                            ddsr_zflx: ''
                                        }))
                                    }} 
                                />
                                 <Icon
                                    type='submit'
                                    title='提交'
                                    disabled={isSubmitting}
                                    style={isSubmitting ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                                    onClick={() => {
                                        // 如果正在提交中，直接返回
                                        if (isSubmitting) {
                                            return;
                                        }
                                        
                                        // 先进行验证
                                        if(info.ddsr_amount === ''){
                                            message.error('请输入金额');
                                            return;
                                        }
                                       
                                        if(info.ddsr_kh_id === ''){
                                            message.error('请选择客户');
                                            return;
                                        }
                                        if(info.ddsr_name === ''){
                                            message.error('请输入收款事由');
                                            return;
                                        }                                       
                                        if(info.ddsr_bm_id === ''){
                                            message.error('请选择部门');
                                            return;
                                        }
                                        if(info.ddsr_date === ''){
                                            message.error('请选择日期');
                                            return;
                                        }
                                        if(info.ddsr_zflx === ''){
                                            message.error('请选择往来类型');
                                            return;
                                        }
                                        // 验证通过后，设置提交状态
                                        setIsSubmitting(true);
                                        addtijiao({
                                            'ddsr_type_id': '1',
                                            'ddsr_type_name': '1',
                                            'ddsr_amount': info.ddsr_amount,
                                            'ddsr_qy_id': props.qy_id,
                                            'ddsr_qy_name': props.qy_name,
                                            'ddsr_num': '1',
                                            'ddsr_zflx': info.ddsr_zflx,
                                            'ddsr_uid': props.yh_id,
                                            'ddsr_uname': props.yh_name,
                                            'ddsr_name': info.ddsr_name,
                                            'ddsr_date': info.ddsr_date?info.ddsr_date:props.dsbzd_date,
                                            'ddsr_kh_id': info.ddsr_kh_id,
                                            'ddsr_kh_name': info.ddsr_kh_name,
                                            'ddsr_price': '',
                                            'ddsr_content': info.ddsr_content,
                                            'ddsr_bzd_id': props.dsbzd_id,
                                            'ddsr_bzd_name': props.dsbzd_name,
                                            'ddsr_bzd_date': props.dsbzd_date,
                                            'ddsr_bzd_xuhao': '',
                                            'ddsr_bzd_date_end': props.dsbzd_date_end,                                            
                                            'ddsr_bm_id': info.ddsr_bm_id?info.ddsr_bm_id:props.dsbzd_bm_id,
                                            'ddsr_bm_name': info.ddsr_bm_name?info.ddsr_bm_name:props.dsbzd_bm_name,
                                            'ddsr_image_name': info.ddsr_image_name?info.ddsr_image_name:'',
                                            'ddsr_image_file': info.ddsr_image_file?info.ddsr_image_file:'',
                                            'ddsr_state': '1',
                                        }).then(res => {
                                            if(res.data.Status==='success'){
                                                message.success('提交成功');
                                                setIsSubmitting(false);
                                                setOpen(false);
                                                
                                                form.resetFields();  
                                            }else{
                                                message.error('提交失败！' + res.data.Message);
                                            }
                                        })     
                                    }}
                                /> 
                            </Space>
                        </Col>
                    </Row>
                </Form>
            </Modal>

        </>
    )
}

export default IncomeAddReportEdit